import {Extension, Node} from '@tiptap/core';

export const CustomBackspaceHandler = Extension.create({
  name: 'customBackspaceHandler',

  addKeyboardShortcuts() {

    return {
      Backspace: ({editor}) => {
        const {state, commands} = editor;
        const {selection} = state;
        const {from} = selection;

        const cursor = selection.$cursor;
        if (!cursor || !cursor.nodeBefore) {
          if (editor.isActive('link')) {
            commands.deleteRange({from: selection.from, to: selection.to});
            editor.chain().focus().unsetLink().run();
            return true;
          }
          return false;
        }

        const nodeBefore = cursor.nodeBefore;
        const linkMark = nodeBefore.marks?.find((mark) => mark.type.name === 'link');
        if (linkMark) {
          commands.setTextSelection({
            from: from  - nodeBefore.nodeSize,
            to: from,
          });
          return true;
        }
        return false;
      },
    };
  },
});

export const CustomImage = Node.create({
  name: 'image',
  group: 'inline',
  inline: true,
  atom: true,
  addAttributes() {
    return {
      ...this.parent?.(),
      'data-id': {
        default: null,
        parseHTML: (element) => element.getAttribute('data-id'),
        renderHTML: (attributes) => {
          if (!attributes['data-id']) return {};
          return {'data-id': attributes['data-id']};
        }
      },
      'data-size': {
        default: null,
        parseHTML: (element) => element.getAttribute('data-size'),
        renderHTML: (attributes) => {
          if (!attributes['data-size']) return {};
          return {'data-size': attributes['data-size']};
        }
      },
      draggable: {
        default: true
      },
      src: {
        default: null,
        parseHTML: element => element.getAttribute('src'),
        renderHTML: attributes => {
          return {
            src: attributes.src
          }
        },
      }
    }
  },
  parseHTML() {
    return[
      {
        tag: 'img[src]'
      }
    ]
  },

  renderHTML({HTMLAttributes}) {
    return [
        'img',
        {
          ...HTMLAttributes,
          class:
          'custom-image image-spinner',
          onload:
          "this.classList.remove('image-spinner');",
        }
    ]
  },
  addCommands() {
    return {
      setImage:
        (options) =>
          ({commands}) => {
          return commands.insertContent({
            type: 'image',
            attrs: options,
          });
      },
    };
  },
});



export const getFileIdsFromEditor = (htmlContent) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, 'text/html');

  return Array.from(doc.querySelectorAll('a[data-id], img[data-id]')).map(link => link.getAttribute('data-id'));
};

export const createNewFileName = (file) => {
  const fileName = file.name.split('.')[0];
  const extension = file.name.split('.').pop();
  return `${fileName}_${Date.now()}.${extension}`;
};

export const formatContentEditor = (htmlContent) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, 'text/html');

  const images = doc.querySelectorAll("img");

  for (let i =0; i < images.length; i++) {
    const img = images[i];
    if (img.getAttribute("src") !== "") {
      img.setAttribute("src", "");
    }
  }

  return doc.body.innerHTML;
};
